import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import BomListTab from '../../modules/bom/BomListTab';
import BomDetailTab from '../../modules/bom/BomDetailTab';


const Bom = (props) => {

    const [activeTab, setActiveTab] = useState('LIST');
    const [selectedRecord, setSelectedRecord] = useState();
    const [t] = useTranslation();

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const handleCallback = (id,action) => {
        switch(action){            
             case 'DETAIL':
                setSelectedRecord(id);
                setActiveTab('DETAIL');                
             break;
             default:
        }
    };

    return (
        <>
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1>{t('workOrder.label.bom')}</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/">{t('menusidebar.label.team')}</Link>
                                </li>
                                <li className="breadcrumb-item active">
                                    {t('workOrder.label.bom')}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <div className="row"></div>
                            <div className="col-12 col-sm-12 col-lg-12" style={{margin: '0 auto',float: 'none'}}>
                                <div className="card card-primary card-outline card-tabs">
                                    <div className="card-header p-0 pt-1 border-bottom-0">
                                        <ul className="nav nav-tabs" role="tablist">
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'LIST'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('LIST')
                                                    }
                                                >
                                                    {t('workOrder.label.list')}
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'DETAIL'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('DETAIL')
                                                    }
                                                >
                                                    {t('workOrder.label.detail')}
                                                </button>
                                            </li>                                          
                                         </ul>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content">
                                            <BomListTab
                                                isActive={activeTab === 'LIST'}
                                                parentCallback={handleCallback}    
                                            />                                                                                                                              
                                             <BomDetailTab
                                                isActive={activeTab === 'DETAIL'}
                                                selectedRecord={selectedRecord}
                                            />  
                                             
                                        </div>
                                    </div>
                                </div>   
                            </div>                         
                </div>
            </section>
        </>
    );
};

export default Bom;